import { Fragment } from 'react'
import { FormattedMessage, useIntl, defineMessages } from 'react-intl'
import styled from 'styled-components'

import { Checkbox } from 'components/v2/Checkbox'
import { Column } from '@10xLabs/react-web/components/Column'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { PlusIcon } from '@10xLabs/react-web/components/Icons/Plus'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { TrashOIcon } from '@10xLabs/react-web/components/Icons/TrashO'
import { Row } from '@10xLabs/react-web/components/Row'
import { InputCurrency } from 'components/InputCurrency'
import { InputNumber } from 'components/InputNumber'
import { Radio } from 'components/v2/Radio'
import { ItemAutocomplete, getItemLabel } from 'features/Snacks/components/ItemAutocomplete'

const H6 = styled.h6<TSFixMe>`
  font-size: 14px;
  margin: 0;
  display: flex;
  align-items: center;
`

const AddItemWrapper = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #1976d2;
  font-size: 16px;

  svg {
    margin-right: 7px;
    fill: #1976d2;
    width: 18px;
    height: 18px;
  }
`

const RadiosWrapper = styled.div<TSFixMe>`
  margin: 0 -5px;
`

const MixedItemsWrapper = styled.div<TSFixMe>`
  margin-left: 50px;
  margin-bottom: 20px;
`

const TrashWrapper = styled.div<TSFixMe>`
  display: flex;
  cursor: pointer;
  margin-left: 20px;
`

const StyledTrashOIcon = styled(TrashOIcon)<TSFixMe>`
  fill: #1976d2;
  width: 16px;
  height: 18px;
`

const NestedTrashWrapper = styled.div<TSFixMe>`
  display: flex;
  cursor: pointer;
  position: relative;
  top: 30px;
`

const messages = defineMessages({
  isMixed: {
    id: 'spanish.inventories.receiveBulkItems.form.item.isMixed',
    defaultMessage: 'Surtido'
  },
  itemNamePlaceholder: {
    id: 'spanish.inventories.receiveBulkItems.form.item.itemName',
    defaultMessage: 'Producto'
  }
})

export const EMPTY_ITEM = {
  isPackage: false,
  isMixed: false,
  packagesQuantity: '',
  nestedItems: [
    {
      id: '',
      name: '',
      units: '',
      netContent: '',
      container: '',
      price: '',
      quantity: ''
    }
  ]
}

export const BulkItemsForm = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const { companyId, values, handleChange, handleBlur, setFieldValue, errors, touched, noPrice } = props

  const addItem = (): TSFixMe => {
    setFieldValue('items', [...values.items, EMPTY_ITEM])
  }

  return (
    <>
      {values.items.map((item: TSFixMe, index: TSFixMe): TSFixMe => {
        const handleRemoveMainItem = (): TSFixMe => {
          setFieldValue('items', [
            ...values.items.filter((_: TSFixMe, itemIndex: TSFixMe): TSFixMe => itemIndex !== index)
          ])
        }

        return (
          <Fragment key={index}>
            <Row>
              <Column>
                <H6>
                  <FormattedMessage
                    id="spanish.inventories.receiveBulkItems.form.item.title"
                    defaultMessage="Producto #{itemCount}"
                    values={{
                      itemCount: index + 1
                    }}
                  />

                  {values.items.length > 1 && (
                    <TrashWrapper onClick={handleRemoveMainItem}>
                      <StyledTrashOIcon />
                    </TrashWrapper>
                  )}
                </H6>
              </Column>
            </Row>

            <Row>
              <Column>
                <RadiosWrapper>
                  <Radio
                    id={`items[${index}].isPackage.false`}
                    name={`items[${index}].isPackage`}
                    checked={!item.isPackage}
                    onChange={({ target: { checked } }): TSFixMe => {
                      setFieldValue(`items[${index}].isPackage`, !checked)
                      setFieldValue(`items[${index}].isMixed`, false)
                      setFieldValue(`items[${index}].nestedItems`, [item.nestedItems[0]])
                    }}
                  >
                    <FormattedMessage
                      id="spanish.inventories.receiveBulkItems.form.items.isUnit"
                      defaultMessage="Unidad"
                    />
                  </Radio>

                  <Radio
                    id={`items[${index}].isPackage.true`}
                    name={`items[${index}].isPackage`}
                    checked={item.isPackage}
                    onChange={({ target: { checked } }): TSFixMe => {
                      setFieldValue(`items[${index}].isPackage`, checked)
                    }}
                  >
                    <FormattedMessage
                      id="spanish.inventories.receiveBulkItems.form.items.isPackage"
                      defaultMessage="Paquete"
                    />
                  </Radio>
                </RadiosWrapper>
              </Column>
            </Row>

            {item.isPackage && (
              <>
                <Row>
                  <Column>
                    <Checkbox
                      id={`items[${index}].isMixed`}
                      checked={item.isMixed}
                      onChange={(event): TSFixMe => {
                        handleChange(event)

                        if (item.nestedItems.length < 2) {
                          setFieldValue(`items[${index}].nestedItems`, [
                            ...item.nestedItems,
                            {
                              ...EMPTY_ITEM.nestedItems[0],
                              price: item.nestedItems[0].price
                            }
                          ])
                        }

                        if (!event.target.checked) {
                          setFieldValue(`items[${index}].nestedItems`, [item.nestedItems[0]])
                        }
                      }}
                    >
                      {intl.formatMessage(messages.isMixed)}
                    </Checkbox>
                  </Column>
                </Row>

                <Row>
                  <Column width="50%">
                    <InputNumber
                      id={`items[${index}].packagesQuantity`}
                      value={item.packagesQuantity}
                      placeholder="1"
                      onChange={(value: TSFixMe): TSFixMe => {
                        setFieldValue(`items[${index}].packagesQuantity`, value)
                      }}
                      onBlur={handleBlur}
                      touched={touched.items && touched.items[index] && touched.items[index].packagesQuantity}
                      errors={errors.items && errors.items[index] && errors.items[index].packagesQuantity}
                      maskOptions={{
                        suffix: '',
                        prefix: '',
                        allowDecimal: false
                      }}
                      label={
                        <FormattedMessage
                          id="spanish.inventories.receiveBulkItems.form.items.packagesQuantity"
                          defaultMessage="Cantidad de paquetes"
                        />
                      }
                    />
                  </Column>
                </Row>
              </>
            )}

            {!item.isMixed && (
              <>
                <Row>
                  <Column width={`${100 / 3}%`}>
                    <ItemAutocomplete
                      placeholder={intl.formatMessage(messages.itemNamePlaceholder)}
                      value={getItemLabel(values.items[index].nestedItems[0], intl)}
                      label={<FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />}
                      onChange={(itemSelected: TSFixMe): TSFixMe => {
                        setFieldValue(`items[${index}].nestedItems[0]`, {
                          ...itemSelected,
                          price: item.nestedItems[0].price,
                          quantity: item.nestedItems[0].quantity
                        })
                      }}
                      companyId={companyId}
                      touched={
                        touched.items &&
                        touched.items[index] &&
                        touched.items[index].nestedItems &&
                        touched.items[index].nestedItems[0] &&
                        touched.items[index].nestedItems[0].id
                      }
                      errors={
                        errors.items &&
                        errors.items[index] &&
                        errors.items[index].nestedItems &&
                        errors.items[index].nestedItems[0] &&
                        errors.items[index].nestedItems[0].id
                      }
                      showOnlyActive
                    />
                  </Column>

                  <Column width={`${100 / 3}%`}>
                    <InputNumber
                      id={`items[${index}].nestedItems[0].quantity`}
                      value={item.nestedItems[0].quantity}
                      placeholder="1"
                      onChange={(value: TSFixMe): TSFixMe => {
                        setFieldValue(`items[${index}].nestedItems[0].quantity`, value)
                      }}
                      onBlur={handleBlur}
                      touched={
                        touched.items &&
                        touched.items[index] &&
                        touched.items[index].nestedItems &&
                        touched.items[index].nestedItems[0] &&
                        touched.items[index].nestedItems[0].quantity
                      }
                      errors={
                        errors.items &&
                        errors.items[index] &&
                        errors.items[index].nestedItems &&
                        errors.items[index].nestedItems[0] &&
                        errors.items[index].nestedItems[0].quantity
                      }
                      maskOptions={{
                        suffix: '',
                        prefix: '',
                        allowDecimal: false
                      }}
                      label={
                        item.isPackage ? (
                          <FormattedMessage
                            id="spanish.inventories.receiveBulkItems.form.items.quantityPerPackage"
                            defaultMessage="Cantidad por paquetes"
                          />
                        ) : (
                          <FormattedMessage
                            id="spanish.inventories.receiveBulkItems.form.items.quantity"
                            defaultMessage="Cantidad"
                          />
                        )
                      }
                    />
                  </Column>

                  {!noPrice && (
                    <Column width={`${100 / 3}%`}>
                      <InputCurrency
                        id={`items[${index}].nestedItems[0].price`}
                        value={item.nestedItems[0].price}
                        placeholder="$10"
                        onChange={(value): TSFixMe => {
                          setFieldValue(`items[${index}].nestedItems[0].price`, value)
                        }}
                        onBlur={handleBlur}
                        touched={
                          touched.items &&
                          touched.items[index] &&
                          touched.items[index].nestedItems &&
                          touched.items[index].nestedItems[0] &&
                          touched.items[index].nestedItems[0].price
                        }
                        errors={
                          errors.items &&
                          errors.items[index] &&
                          errors.items[index].nestedItems &&
                          errors.items[index].nestedItems[0] &&
                          errors.items[index].nestedItems[0].price
                        }
                        label={
                          <FormattedMessage
                            id="spanish.inventories.receiveBulkItems.form.items.price"
                            defaultMessage="Precio unitario"
                          />
                        }
                        hideSuffix
                      />
                    </Column>
                  )}
                </Row>
              </>
            )}

            {item.isMixed && (
              <>
                <MixedItemsWrapper>
                  {item.nestedItems.map((nestedItem: TSFixMe, nestedItemIndex: TSFixMe): TSFixMe => {
                    const handleRemoveNestedItem = (): TSFixMe => {
                      setFieldValue(
                        `items[${index}].nestedItems`,
                        item.nestedItems.filter(
                          (_: TSFixMe, itemIndex: TSFixMe): TSFixMe => itemIndex !== nestedItemIndex
                        )
                      )
                    }

                    return (
                      <Row key={nestedItemIndex}>
                        <Column width="calc(50% - 20px)">
                          <ItemAutocomplete
                            placeholder={intl.formatMessage(messages.itemNamePlaceholder)}
                            value={getItemLabel(nestedItem, intl)}
                            label={<FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />}
                            onChange={(itemSelected: TSFixMe): TSFixMe => {
                              setFieldValue(`items[${index}].nestedItems[${nestedItemIndex}]`, {
                                ...itemSelected,
                                price: item.nestedItems[nestedItemIndex].price,
                                quantity: item.nestedItems[nestedItemIndex].quantity
                              })
                            }}
                            companyId={companyId}
                            touched={
                              touched.items &&
                              touched.items[index] &&
                              touched.items[index].nestedItems &&
                              touched.items[index].nestedItems[nestedItemIndex] &&
                              touched.items[index].nestedItems[nestedItemIndex].id
                            }
                            errors={
                              errors.items &&
                              errors.items[index] &&
                              errors.items[index].nestedItems &&
                              errors.items[index].nestedItems[nestedItemIndex] &&
                              errors.items[index].nestedItems[nestedItemIndex].id
                            }
                            showOnlyActive
                          />
                        </Column>

                        <Column width="calc(50% - 20px)">
                          <InputNumber
                            id={`items[${index}].nestedItems[${nestedItemIndex}].quantity`}
                            value={item.nestedItems[nestedItemIndex].quantity}
                            placeholder="1"
                            onChange={(value: TSFixMe): TSFixMe => {
                              setFieldValue(`items[${index}].nestedItems[${nestedItemIndex}].quantity`, value)
                            }}
                            onBlur={handleBlur}
                            touched={
                              touched.items &&
                              touched.items[index] &&
                              touched.items[index].nestedItems &&
                              touched.items[index].nestedItems[nestedItemIndex] &&
                              touched.items[index].nestedItems[nestedItemIndex].quantity
                            }
                            errors={
                              errors.items &&
                              errors.items[index] &&
                              errors.items[index].nestedItems &&
                              errors.items[index].nestedItems[nestedItemIndex] &&
                              errors.items[index].nestedItems[nestedItemIndex].quantity
                            }
                            maskOptions={{
                              suffix: '',
                              prefix: '',
                              allowDecimal: false
                            }}
                            label={
                              <FormattedMessage
                                id="spanish.inventories.receiveBulkItems.form.items.quantityPerPackage"
                                defaultMessage="Cantidad por paquetes"
                              />
                            }
                          />
                        </Column>

                        <Column width="40px">
                          {item.nestedItems.length > 2 && (
                            <NestedTrashWrapper onClick={handleRemoveNestedItem}>
                              <StyledTrashOIcon />
                            </NestedTrashWrapper>
                          )}
                        </Column>
                      </Row>
                    )
                  })}

                  <Row>
                    <Column>
                      <AddItemWrapper
                        onClick={(): TSFixMe => {
                          setFieldValue(`items[${index}].nestedItems`, [
                            ...values.items[index].nestedItems,
                            EMPTY_ITEM.nestedItems[0]
                          ])
                        }}
                      >
                        <PlusIcon />
                      </AddItemWrapper>
                    </Column>
                  </Row>
                </MixedItemsWrapper>

                {!noPrice && (
                  <Row>
                    <Column width="50%">
                      <InputCurrency
                        id={`items[${index}].nestedItems[0].price`}
                        value={item.nestedItems[0].price}
                        placeholder="$10"
                        onChange={(value): TSFixMe => {
                          values.items[index].nestedItems.forEach(
                            (nestedItem: TSFixMe, nestedItemIndex: TSFixMe): TSFixMe => {
                              setFieldValue(`items[${index}].nestedItems[${nestedItemIndex}].price`, value)
                            }
                          )
                        }}
                        onBlur={handleBlur}
                        touched={
                          touched.items &&
                          touched.items[index] &&
                          touched.items[index].nestedItems &&
                          touched.items[index].nestedItems[0] &&
                          touched.items[index].nestedItems[0].price
                        }
                        errors={
                          errors.items &&
                          errors.items[index] &&
                          errors.items[index].nestedItems &&
                          errors.items[index].nestedItems[0] &&
                          errors.items[index].nestedItems[0].price
                        }
                        label={
                          <FormattedMessage
                            id="spanish.inventories.receiveBulkItems.form.items.price"
                            defaultMessage="Precio unitario"
                          />
                        }
                        hideSuffix
                      />
                    </Column>
                  </Row>
                )}
              </>
            )}
          </Fragment>
        )
      })}

      <Row>
        <Column>
          <AddItemWrapper onClick={addItem}>
            <PlusIcon />

            <FormattedMessage
              id="spanish.inventories.receiveBulkItems.form.items.addItem"
              defaultMessage="Agregar producto"
            />
          </AddItemWrapper>
        </Column>
      </Row>
    </>
  )
}
